var map = {
	"./discord.png": "6914",
	"./facebook.png": "6dbe",
	"./instagram.png": "d717",
	"./linkedin.png": "6a904",
	"./twitter.png": "9979",
	"./youtube.png": "5341"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb1d";